<template>
  <div class="cadastro-usuario">
    <v-container
      fluid
    >
      <h1 class="titulo">Afiliados Estatísticas</h1>

      <div class="box-table">
        <expansionPanelDefault :handleClick="montarLabelFiltro">
          <v-row class="justify-end">
            <v-col cols="12" md="2">
              <FiltroRangeDate
                class="mr-3 range-date"
                @input="filtrar"
                :value="rangeDate"
                :labelBtn="'Selecionar Data'"
                :actionLabels="{ apply: 'OK' }"
                style="width: 100%;"
                :disableBtnClear="false"
              />
            </v-col>
          </v-row>
        </expansionPanelDefault>

        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="listaItens"
            width="300px"
            flat
            hide-default-footer
            :loading="loadingPag"
            :items-per-page.sync="itemsPerPage"> 

            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="7"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>

      <v-btn class="mx-2 fab-cadastrar-usuario" fab color="primary" @click="cadastrar">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-container>

    <BrModalCadastro />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
import Events from '@/core/service/events'
import { errorSnackbar } from '@/core/service/utils'
import moment from 'moment'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

export default {
  name: 'AfiliadosStatisticas',
  components: {
    // BrToolBar: () => import('./components/toolbar'),
    BrModalCadastro: () => import('@/views/components/modalDadosUsuario'),
    FiltroRangeDate: () => import('@/views/components/filtroRangeDate'),
    expansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
  },
  mixins: [listagemTables],
  data () {
    return {
      typeBusca: 'entities',
      loadingTable: false,
      headers: [
        { align: 'start', class: 'table-header', text: 'Id', value: 'id' },
        { align: 'start', class: 'table-header', text: 'Nome', value: 'type.name' },
        { align: 'start', class: 'table-header', text: 'URL', value: 'campaign.url' },
        { align: 'start', class: 'table-header', text: 'Tag', value: 'campaign.tag' },
        { align: 'start', class: 'table-header', text: 'Afiliado Origin', value: 'entity.jsonData.fullName' },
        { align: 'start', class: 'table-header', text: 'QTD', value: 'value' },
        { align: 'start', class: 'table-header', text: 'Data Solicitação', value: 'affiliate.created' },
        // { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
      ],
      rangeDate: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      loadingPag: false,
    }
  },

  async mounted () {
    this.loadingTable = true
    this.getData()
  },

  computed: {
    ...mapGetters('afiliadosStatisticas', ['listaItens', 'totalItens']),
  },

  methods: {
    ...mapActions('afiliadosStatisticas', ['obterAfiliados']),

    init () {},

    filtrar (e) {
      this.rangeDate = {
        start: e.start,
        end: e.end
      }
      this.getData(e.start, e.end)
    },
    getData () {
      this.loadingTable = true
      this.filter = {
        'CampaignStatistics:created_>=': this.rangeDate.start,
        'CampaignStatistics:created_<=': this.rangeDate.end
      }
      this.obterAfiliados({ page: this.page, pageSize: this.$store.getters.ItensPaginacao,  _addlFilter: this.filter ? this.filter : undefined })
        .catch(err => {
          console.log(err)
          errorSnackbar(err.error)
        })
        .finally(() => this.loadingTable = false)
    },

    openModalDadosUsuarios (e) {
      Events.$emit('cadastro::openModalCadastro', e)
    },

    montarLabelFiltro(){     
      Events.$on('autoCompleteEntities::getSearchText', (val)=>{ this.terminalTextSelected = val })
      let labelFiltro = [
      {
          label: 'Data Inicial:',
          value: moment(this.rangeDate.start).format('DD/MM/YYYY')
        },
        {
          label: 'Data Final:',
          value: moment(this.rangeDate.end).format('DD/MM/YYYY')
        },
    ]
      // codBilhete, entity
      return labelFiltro
    },
  }
}
</script>

<style lang="scss">
  @import '../../../assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {

    .v-data-table-header-mobile {
      display: none;
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }
</style>>
